<template>
  <div>
    <span class="actionSecondary">{{computedType}}</span>
    <span v-if="condition.descriptionPrimary">{{condition.descriptionPrimary}}</span>
    <span
      style="color:gray;"
      v-if="condition.descriptionSecondary"
    >{{condition.descriptionSecondary}}</span>
  </div>
</template>

<script>
export default {
  name: "ConditionDescription",
  props: ["condition"],
  computed: {
    computedType() {
      return this.condition.conditionType == "conditionQuestion"
        ? " Question"
        : " Category";
    }
  }
};
</script>

<style scoped>
.actionSecondary {
  color: orange;
}
</style>